import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"display":"none"},
  "aria-hidden": "true"
}

import { useStore } from 'vuex';
import { computed, watch } from 'vue';
import { swalConfirm } from '@/core/helpers/utils';
import { blurActiveElement } from '@/core/directives/dialogAutoFocus';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseConfirmationDialog',
  setup(__props) {

const store = useStore();

const dialogVisible = computed(
  () => store.getters['ConfirmationDialogModule/isDialogOpen'] as boolean
);

const dialogTitle = computed(
  () => store.getters['ConfirmationDialogModule/getDialogTitle'] as string
);
const dialogMessage = computed(
  () => store.getters['ConfirmationDialogModule/getDialogMessage'] as string
);
const confirmButtonText = computed(
  () => store.getters['ConfirmationDialogModule/getConfirmText'] as string
);
const cancelButtonText = computed(
  () => store.getters['ConfirmationDialogModule/getCancelText'] as string
);
const confirmCallback = computed(
  () => store.getters['ConfirmationDialogModule/getOnConfirm'] as () => void | Promise<void>
);

let isPromptOpen = false;

watch(
  dialogVisible,
  async (visible) => {
    if (!visible || isPromptOpen) {
      return;
    }

    isPromptOpen = true;
    blurActiveElement();

    try {
      const confirmed = await swalConfirm({
        title: dialogTitle.value,
        text: dialogMessage.value,
        confirmButtonText: confirmButtonText.value,
        cancelButtonText: cancelButtonText.value,
      });

      const onConfirm = confirmCallback.value;

      store.commit('ConfirmationDialogModule/closeDialog');
      isPromptOpen = false;

      if (confirmed) {
        await onConfirm?.();
      }
    } finally {
      isPromptOpen = false;
    }
  },
  { flush: 'sync' }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1))
}
}

})